export const WATCHLIST_GROUPS = "WATCHLIST_GROUPS";
export const WATCHLIST_GROUPS_ERROR = "WATCHLIST_GROUPS_ERROR";
export const WATCHLIST_GROUPS_HIDE_ERROR = "WATCHLIST_GROUPS_HIDE_ERROR";
export const WATCHLIST_GROUPS_START_LOADER = "WATCHLIST_GROUPS_START_LOADER";
export const WATCHLIST_GROUPS_STOP_LOADER = "WATCHLIST_GROUPS_STOP_LOADER";
